<template>
<v-card style="height:90vh">
<v-toolbar flat color="#273C51" height="42">
  <v-toolbar-title style="color:white">
<span v-if="posts.editStatus== 'edit'">Редактирование поста - {{posts.selectedPost.post_id}}</span>
<span v-if="posts.editStatus== 'copy'">Добавление поста по шаблону </span>
  </v-toolbar-title>
<v-spacer/>
<v-icon @click="$router.go();posts.modals.editor = false" color="white">mdi-close</v-icon>
</v-toolbar>

<v-card-text>

<v-text-field v-if="posts.editStatus== 'edit'" disabled style="margin-bottom:10px" hide-details v-model="posts.selectedPost.post_id" solo  clearable label="Ссылка на пост, например wall123_12"></v-text-field>
<v-text-field v-if="posts.editStatus== 'copy'"   style="margin-bottom:10px" hide-details v-model="posts.selectedPost.post_id" solo  clearable label="Ссылка на пост, например wall123_12">
  <v-tooltip slot="prepend-inner" top >
  <span>Создать новый пост</span>
  <v-icon @click="openNewPost()" slot="activator" color="green">mdi-plus</v-icon>
  </v-tooltip>
</v-text-field>

<div>
<b-card no-body>
<b-tabs   card>


<b-tab>
<template #title>
<v-icon small color="green">mdi-worker</v-icon> <strong style="margin-left:5px">Действия поста</strong>
</template>

<v-layout>
<v-flex md6>
<v-checkbox v-model="posts.selectedPost.params.acts.repost.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Репост в лс</span>
</v-checkbox>
</v-flex>
<template v-if="posts.selectedPost.params.acts.repost.is">
<v-text-field v-model="posts.selectedPost.params.acts.repost.limit"
label="Задать лимит" type="number" flat  hide-details dense style="margin-right:25px">
</v-text-field>
<v-flex md3>
<v-switch v-model="posts.selectedPost.params.acts.repost.isBlock"   color="red" hide-details >
<span v-if="posts.selectedPost.params.acts.repost.isBlock" style="margin-top:6px" slot="label">Разблокировать</span>
<span v-else style="margin-top:6px" slot="label">Заблокировать</span>
</v-switch>
</v-flex>
<v-flex md3>
<v-switch disabled v-model="activatedParam" v-if="posts.selectedPost.params.selectedAct == 'repost'"   color="green" hide-details >
<span style="margin-top:6px;color:green" slot="label">Активирован</span>
</v-switch>
<v-switch @click="activateAct('repost')"  v-else  color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать</span>
</v-switch>
</v-flex>
</template>
</v-layout>

<div v-if="posts.selectedPost.params.acts.repost.is"  style="margin:10px;margin-left:0px">
<v-textarea  v-model="posts.selectedPost.params.acts.repost.helloSms.text" solo   color="#4A76A8" label="Введите приветствие. Оставьте пустым, если хотите отсылать репост всегда."></v-textarea>
</div>

<div v-if="posts.selectedPost.params.acts.repost.is"  style="margin:10px;margin-left:0px">
<v-textarea  v-model="posts.selectedPost.params.acts.repost.sms.text"  solo   color="#4A76A8" label="Введите содержимое прикрепленного сообщения"></v-textarea>
</div>


<v-layout>
<v-flex md6>
<v-checkbox v-model="posts.selectedPost.params.acts.link.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Отправить ссылку в лс</span>
</v-checkbox>
</v-flex>
<template v-if="posts.selectedPost.params.acts.link.is">
<v-text-field v-model="posts.selectedPost.params.acts.link.limit"
label="Задать лимит" type="number" flat  hide-details dense style="margin-right:25px">
</v-text-field>
<v-flex md3>
<v-switch v-model="posts.selectedPost.params.acts.link.isBlock"   color="red" hide-details >
<span v-if="posts.selectedPost.params.acts.link.isBlock" style="margin-top:6px" slot="label">Разблокировать</span>
<span v-else style="margin-top:6px" slot="label">Заблокировать</span>
</v-switch>
</v-flex>
<v-flex md3>
<v-switch disabled v-model="activatedParam" v-if="posts.selectedPost.params.selectedAct == 'link'"   color="green" hide-details >
<span style="margin-top:6px;color:green" slot="label">Активирован</span>
</v-switch>
<v-switch @click="activateAct('link')"   v-else  color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать</span>
</v-switch>
</v-flex>


</template>
</v-layout>
<div v-if="posts.selectedPost.params.acts.link.is"  style="margin:10px;margin-left:0px">
<v-textarea  v-model="posts.selectedPost.params.acts.link.helloSms.text" solo   color="#4A76A8" label="Введите приветствие. Оставьте пустым, если хотите отсылать репост всегда."></v-textarea>
</div>
<v-layout v-if="posts.selectedPost.params.acts.link.is"  style="margin:10px;margin-left:0px">
<v-flex md6 style="margin-right:15px">
<v-textarea v-model="posts.selectedPost.params.acts.link.sms.beforeLink" hide-details solo  color="#4A76A8" label="Текст до ссылки"></v-textarea>
<v-textarea v-model="posts.selectedPost.params.acts.link.sms.afterLink" style="margin-top:10px" hide-details solo     color="#4A76A8" label="Текст после ссылки"></v-textarea>
</v-flex>

<v-flex md5>
<v-switch v-model="posts.selectedPost.params.acts.link.links.linkOnPage"  class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label"> https://vk.com/id123</span>
</v-switch>
<v-switch v-model="posts.selectedPost.params.acts.link.links.linkOnPost" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label"> https://vk.com/id123?w=wall123_1</span>
</v-switch>
<v-switch v-model="posts.selectedPost.params.acts.link.links.linkOnPostSimple" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label"> https://vk.com/wall123_1</span>
</v-switch>
<v-switch v-model="posts.selectedPost.params.acts.link.links.hyperLink.is" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать гиперссылку</span>
</v-switch>
<v-textarea v-if="posts.selectedPost.params.acts.link.links.hyperLink.is" v-model="posts.selectedPost.params.acts.link.links.hyperLink.text" hide-details solo  color="#4A76A8" label="Текст гиперссылки "></v-textarea>
</v-flex>
</v-layout>


<v-layout>
<v-flex md6>
<v-checkbox v-model="posts.selectedPost.params.acts.smsWithoutLink.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Сообщение + Репост на стену </span>
</v-checkbox>
</v-flex>
<template v-if="posts.selectedPost.params.acts.smsWithoutLink.is">
<v-text-field v-model="posts.selectedPost.params.acts.smsWithoutLink.limit"
label="Задать лимит" type="number" flat  hide-details dense style="margin-right:25px">
</v-text-field>
<v-flex md3>
<v-switch   v-model="posts.selectedPost.params.acts.smsWithoutLink.isBlock"   color="red" hide-details >
<span v-if="posts.selectedPost.params.acts.smsWithoutLink.isBlock" style="margin-top:6px" slot="label">Разблокировать</span>
<span v-else style="margin-top:6px" slot="label">Заблокировать</span>
</v-switch>
</v-flex>
<v-flex md3>
<v-switch disabled v-model="activatedParam" v-if="posts.selectedPost.params.selectedAct == 'smsWithoutLink'"   color="green" hide-details >
<span style="margin-top:6px;color:green" slot="label">Активирован</span>
</v-switch>
<v-switch @click="activateAct('smsWithoutLink')"   v-else  color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать</span>
</v-switch>
</v-flex>


</template>
</v-layout>
<v-layout v-if="posts.selectedPost.params.acts.smsWithoutLink.is"  style="margin:10px;margin-left:0px">
<v-flex md6 style="margin-right:15px">
<v-textarea v-model="posts.selectedPost.params.acts.smsWithoutLink.sms.text" hide-details solo color="#4A76A8" label="Введите текст сообщения"></v-textarea>
</v-flex>

<v-flex md5>
<v-textarea v-model="posts.selectedPost.params.acts.smsWithoutLink.makeRepostOnWall.text" hide-details solo color="#4A76A8" label="Введите текст, к репосту поста"></v-textarea>
</v-flex>

</v-layout>

</b-tab>



<b-tab>
<template #title>
<v-icon small color="yellow">mdi-tune</v-icon> <strong style="margin-left:5px">Основные параметры</strong>
</template>
<v-select style="margin-bottom:10px" hide-details label="Выбрать задание" clearable item-value = "task_id" item-text="name"
v-model="posts.selectedPost.task_id" :items="tasks"
>
</v-select>

<v-select style="margin-bottom:10px" hide-details   label="Изменить статус поста"   item-value = "value" item-text="title"
v-model="posts.selectedPost.status" :items="postStatusList"
>
</v-select>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.set_importance"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Наследовать избранность поста ?</span>
</v-checkbox>


</b-tab>



<b-tab>
<template #title>
<v-icon small color="red">mdi-block-helper</v-icon> <strong style="margin-left:5px">Обработка блокировок</strong>
</template>

<div>
<b-alert show variant="info">
Активное действие будет блокированно, если за {{posts.selectedPost.params.blockActTime.min}} мин. вк заблокирует {{posts.selectedPost.params.blockActTime.acc_count}} акк.
</b-alert>
<v-layout style="margin-left:15px">
<v-flex md5>
  <v-subheader>Минуты</v-subheader>
  <v-slider
  v-model="posts.selectedPost.params.blockActTime.min"
  max="59"
  min="1"
  color="primary"
  thumb-label="always"
  ></v-slider>
</v-flex>
<v-flex md5 style="margin-left:25px">
  <v-subheader>Блокированные аккаунты</v-subheader>
  <v-slider
  v-model="posts.selectedPost.params.blockActTime.acc_count"
  max="59"
  min="1"
  color="primary"
  thumb-label="always"
  ></v-slider>
</v-flex>
</v-layout>



<b-alert show variant="info">
Анализировать пост на валидность ссылки и страницы, на которой пост.
</b-alert>

<v-layout style="margin-left:15px">
<v-flex md12 style="">
    <v-subheader>Интервал в минутах:  <span style="margin-left:3px" v-if="posts.selectedPost.params.check_post.interval == 0"> постоянно перед каждым действием</span><span v-else style="margin-left:3px">{{posts.selectedPost.params.check_post.interval}}</span></v-subheader>
    <v-slider
    v-model="posts.selectedPost.params.check_post.interval"
    max="59"
    min="0"
    color="primary"
    thumb-label="always"
    ></v-slider>

</v-flex>
</v-layout>






<b-alert show variant="info">
Автогенерация поста
</b-alert>
<v-switch v-model="posts.selectedPost.params.autoGenerate.is" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать автогенерацию</span>
</v-switch>

<v-layout v-if="posts.selectedPost.params.autoGenerate.is" style="">

<v-flex md7 style="">
<v-textarea  rows="10" v-model="posts.selectedPost.params.autoGenerate.pattern" solo placeholder="Введите шаблон тела поста. Возможно использовать рандомизацию, указав тег <tele-link>, будет сгенерирована новая телеграмм ссылка. Например: Вот  {тут|здесь} <tele-link> информация."></v-textarea>
<div style="margin-top:-10px">  <v-text-field hide-details  solo clearable v-model="posts.selectedPost.params.autoGenerate.linkUrl" color="#4A76A8" label="Тег ссылки, например: <tele-link>"></v-text-field> </div>
<div v-if="posts.selectedPost.params.autoGenerate.make_comment.is" style="margin-top:5px">  <v-text-field hide-details  solo clearable v-model="posts.selectedPost.params.autoGenerate.make_comment.text" color="#4A76A8" label="Ваш комментарий"></v-text-field> </div>

</v-flex>

<v-flex md5 style="margin-left:10px;margin-top:-5px">
<v-card  style="margin-left:5px;margin-top:5px"><v-card-text >
<v-select
v-model = 'posts.selectedPost.params.autoGenerate.selectedAccGroup' hide-details
:items="posts.newPost.accGroupsList.slice(1)"
item-text = 'title_ru'
item-value = 'gr_id'
label="Выберите группу аккаунтов">
</v-select>
<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.onlyWithoutPosts"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Только аккаунты без постов</span>
</v-checkbox>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.onlyOpenedAccounts"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Только открытые аккаунты</span>
</v-checkbox>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.pin"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Закрепить на стене</span>
</v-checkbox>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.close_comments"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Отключить комментарии</span>
</v-checkbox>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.add_like"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Поставить личный лайк</span>
</v-checkbox>

<v-checkbox class="pa-0 ma-0" v-model="posts.selectedPost.params.autoGenerate.make_comment.is"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Добавить комментарий</span>
</v-checkbox>
</v-card-text></v-card>
</v-flex>

</v-layout>




</div>


</b-tab>


</b-tabs>
</b-card>
</div>




</v-card-text>



<v-card-actions>
  <p v-if="posts.editStatus== 'copy' && !posts.selectedPost.post_id" style="color:red"><strong>Не забудьте указать ссылку на пост !</strong></p>
  <v-btn v-if="posts.editStatus== 'edit'" @click="editPost()"  color="#4A76A8"   flat  block style="text-transform:none">
   <v-icon> mdi-pencil </v-icon> <span style="margin-left:5px"> Редактировать пост </span>
  </v-btn>
  <v-btn :disabled="!posts.selectedPost.post_id" v-if="posts.editStatus== 'copy'" @click="editPost()"  color="#4A76A8"   flat  block style="text-transform:none">
   <v-icon> mdi-plus </v-icon> <span style="margin-left:5px"> Добавить пост </span>
  </v-btn>
</v-card-actions>


</v-card>
</template>

<script>
import axios from 'axios'
export default {
props: ['posts'],
data () {
return {
postStatusList:[
  {title:'Не используется', value:"1"},
  {title:'Выбранный', value:"2"},
  {title:'Блокирован', value:"3"},
  {title:'Бловкирован в vk', value:"4"}
],
activatedParam:true,
tasks:[],
disable:true
}
},
methods: {
openNewPost(){
this.posts.modals.newPost = true
},
activateAct(act){
this.posts.selectedPost.params.selectedAct = act

},
editPost(){
axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/add_posts.php', {
params:{
  params:this.posts.selectedPost,
  editStatus:this.posts.editStatus,
}
}).then(response => {
this.$router.go()

})
},

tasksData(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
method: 'POST',
data: {
contentType: 'pages'
}
})
.then( response => {
  response.data.forEach(item=>{
  item.actions = JSON.parse(item.actions)
  if(item.actions.postActions.activated === true){this.tasks.push(item)}
  })
})

},

},
computed:{
},
mounted(){
this.tasksData()
},

}
</script>

<style    >

</style>
